import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { NumberInput, TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function OffreTacheFields({ item, set, tab }) {
    const t = useTranslations()
    return <>
        <Row>
            <TextInput className="grow" label={t("Nom FR")} value={item.nomFr} onChange={set('nomFr')} required />
            <TextInput className="grow" label={t("Nom NL")} value={item.nomNl} onChange={set('nomNl')} />
            <TextInput className="grow" label={t("Nom EN")} value={item.nomEn} onChange={set('nomEn')} />
        </Row>
        <Row>
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} required />
        </Row>
    </>
}

export function OffreTachesList(props) {
    const t = useTranslations()
    return <ListPage model="offreTaches" title={t("Tâches")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Nom FR')]: 'nomFr',
        [t('Nom NL')]: 'nomNl',
        [t('Nom EN')]: 'nomEn',
    }} {...props} />
}

export function OffreTacheDetail(props) {
    const t = useTranslations()
    return <DetailPage model="offreTaches" title={t("Tâche")} Fields={OffreTacheFields} {...props} />
}
